import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chainguard = defineConnector({
  identifier: "chainguard",
  name: "Chainguard",
  tagLine: "The trusted source for open source",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Create a Chainguard pull token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Chainguard Console](https://console.chainguard.dev/), open your organization’s settings and create a pull token, or run `chainctl auth configure-docker --pull-token`. Both produce a username and password for `cgr.dev`.",
        },
      ],
    },
    {
      title: "Enter your Chainguard details",
      items: [
        {
          kind: "input",
          label: "Organization name",
          required: true,
          placeholder: "company-name",
          helperText: "Your images live under cgr.dev/<organization name>.",
          target: { kind: "configuration", field: "orgName" },
        },
        {
          kind: "input",
          label: "Pull token username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Pull token password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  defaultUrlPattern: () => "https://cgr\\.dev/.*",
  usageHint: ({ orgName }) =>
    `Images are pulled from cgr.dev/${orgName}/<image>. The pull token is sent as basic auth, the same credentials docker login uses.`,
  connectionTest: {
    protocol: "http",
    request: () => "https://cgr.dev/token?service=cgr.dev",
  },
});
